import React from "react";
import ReactModal from "react-modal";
import "../../../Styles/Settings/WarningSetting.css";

const UnSavedModal = ({ isOpen, onClose }) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      borderRadius: "15px",
      transform: "translate(-50%, -50%)",
      width: "40%",
      height: "20%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "Space-between",
      gap: "2rem",
      padding: "px !important",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
    >
      <div className="warning_setting-main-container">
        <div className="sub-container-warning">
          <div className="sub-container-warning-heading">Leave the page? </div>
          <div className="sub-container-warning-des">
            Are you sure you want to leave without saving
          </div>
          <div className="cancel-btn-warning-container">
            <button
              className="cancel-canbtn-warning-container"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="cancel-disbtn-warning-container"
              onClick={onClose}
            >
              Discard
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

export default UnSavedModal;
